<template>
    <div>
        <limitless-page-header :title="'Bildbank'" sub-title="kategorier">
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'mediabank.categories' }" icon="icon-plus3">Kategorier</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <mediabank-browser @select="rowClick" upload></mediabank-browser>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import MediabankBrowser from '@components/MediabankBrowser.vue';

export default {
    name: 'MediabankImageList',
    components: {
        MediabankBrowser,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/mediabank/' + row.image_id).focus();
            } else {
                this.$router.push({ name: 'mediabank.edit', params: { id: row.image_id } });
            }
        },
    },
};

</script>
